import api from "./index";
import { ENDPOINTS } from "./endpoints";

export const saveProduct = (data)=>
  api.post(ENDPOINTS.BUYER_SAVED.SAVE,data);

export const listSavedProducts = ()=>
  api.get(ENDPOINTS.BUYER_SAVED.LIST);

export const removeSavedProduct = (id)=>
  api.delete(ENDPOINTS.BUYER_SAVED.DELETE(id));